var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple4F8192Ac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_apple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8281 20.1758C28.8125 17.5117 30.0195 15.5039 32.457 14.0234C31.0938 12.0703 29.0312 10.9961 26.3125 10.7891C23.7383 10.5859 20.9219 12.2891 19.8906 12.2891C18.8008 12.2891 16.3086 10.8594 14.3477 10.8594C10.3008 10.9219 6 14.0859 6 20.5234C6 22.4258 6.34766 24.3906 7.04297 26.4141C7.97266 29.0781 11.3242 35.6055 14.8203 35.5C16.6484 35.457 17.9414 34.2031 20.3203 34.2031C22.6289 34.2031 23.8242 35.5 25.8633 35.5C29.3906 35.4492 32.4219 29.5156 33.3047 26.8438C28.5742 24.6133 28.8281 20.3125 28.8281 20.1758ZM24.7227 8.26172C26.7031 5.91016 26.5234 3.76953 26.4648 3C24.7148 3.10156 22.6914 4.19141 21.5391 5.53125C20.2695 6.96875 19.5234 8.74609 19.6836 10.75C21.5742 10.8945 23.3008 9.92188 24.7227 8.26172Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple4F8192Ac);
export default __webpack_public_path__ + "static/media/apple-4f8192ac.47cf52779cf08d6d34cdb39a23a11323.svg";
export { ForwardRef as ReactComponent };